import { render } from "./GatewaySessionPromptModal.vue?vue&type=template&id=72c35268&scoped=true"
import script from "./GatewaySessionPromptModal.vue?vue&type=script&lang=js"
export * from "./GatewaySessionPromptModal.vue?vue&type=script&lang=js"

import "./GatewaySessionPromptModal.vue?vue&type=style&index=0&id=72c35268&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c35268"]])

export default __exports__